import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "tr_admin_token";
const ADMIN_KEY = "tr_admin_user";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setSession(token, admin) {
  localStorage.setItem(TOKEN_KEY, token);
  if (admin) localStorage.setItem(ADMIN_KEY, JSON.stringify(admin));
}

export function getStoredAdmin() {
  try {
    const raw = localStorage.getItem(ADMIN_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ADMIN_KEY);
}

export const adminApi = axios.create({ baseURL: API });

adminApi.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearSession();
      if (typeof window !== "undefined" && !window.location.pathname.endsWith("/admin/login")) {
        window.location.replace("/admin/login");
      }
    }
    return Promise.reject(err);
  }
);

export async function adminLogin(email, password) {
  const { data } = await adminApi.post("/admin/login", { email, password });
  setSession(data.access_token, data.admin);
  return data.admin;
}

export async function fetchStats() {
  const { data } = await adminApi.get("/admin/stats");
  return data;
}

export async function fetchApplications(params = {}) {
  const { data } = await adminApi.get("/admin/applications", { params });
  return data;
}

export async function patchApplication(id, body) {
  const { data } = await adminApi.patch(`/admin/applications/${id}`, body);
  return data;
}

export async function fetchContacts(params = {}) {
  const { data } = await adminApi.get("/admin/contacts", { params });
  return data;
}

export async function patchContact(id, body) {
  const { data } = await adminApi.patch(`/admin/contacts/${id}`, body);
  return data;
}

export function csvUrl(kind, params = {}) {
  const qs = new URLSearchParams(params).toString();
  return `${API}/admin/${kind}/export.csv${qs ? `?${qs}` : ""}`;
}

export async function downloadCsv(kind, params = {}) {
  const response = await adminApi.get(`/admin/${kind}/export.csv`, {
    params,
    responseType: "blob",
  });
  const blob = new Blob([response.data], { type: "text/csv" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.href = url;
  const match = /filename="([^"]+)"/.exec(
    response.headers["content-disposition"] || ""
  );
  link.download = match ? match[1] : `${kind}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
